import axios from "axios";
export const getToken = () => localStorage.getItem('token');

const BASE_URL = "https://n8n.convertifile.com";

const decodeTokenPayload = (token) => {
  if (!token) return null;

  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};

export const saveToken = (token) => {
  localStorage.setItem('token', token);
};

export const logout = (redirectTo = "/login") => {
  localStorage.removeItem('token');
  window.location = redirectTo;
};

export const isAuthenticated = () => {
  const token = getToken();
  const payload = decodeTokenPayload(token);

  if (!payload) {
    localStorage.removeItem('token');
    return false;
  }

  if (payload.exp && Date.now() >= payload.exp * 1000) {
    localStorage.removeItem('token');
    return false;
  }

  return true;
};

export const getUserFromToken = () => {
  const payload = decodeTokenPayload(getToken());
  if (!payload) return null;

  const name = payload.Id?.split('.')?.[0];
  if (!name) return 'User';

  return name[0]?.toUpperCase() + name.slice(1);
};

// ✅ GET Career Leads
export const getCareerLeads = async () => {
  return axios.get(`${BASE_URL}/webhook/get-careers`);
};

// ✅ Get Resume PDF
export const getResumePdf = async (name) => {
  return axios.post(
    `https://n8n.convertifile.com/webhook/get-pdf`,
    { name },
    { responseType: "blob" }
  );
};

// ✅ GET Issues
export const getIssues = async () => {
  return axios.get(`${BASE_URL}/webhook/get-issues`);
};

export const getContactLeads = () =>
  axios.get(`${BASE_URL}/webhook/get-contacts`);

export const submitLeadGeneration = (formData) =>
  axios.post(
    `${BASE_URL}/webhook/f4e83e47-d8b5-4d16-9b39-9a7c86626907`,
    formData
  );


  // ✅ Login API (Basic Auth)
export const loginUser = (userId, password) => {
  const credentials = btoa(`${userId}:${password}`);

  return axios.post(
    `${BASE_URL}/webhook/0eb9ac50-f2c0-468f-9bf9-11e68d8dbe53`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${credentials}`,
      },
    }
  );
};

// ✅ Upload File with Progress + Auth
export const uploadFile = (formData, token, onUploadProgress) => {
  return axios.post(
    `${BASE_URL}/webhook/77e06be9-5f68-48bd-ac9c-333424f77e34`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        // ❌ do NOT manually set multipart/form-data (axios handles it)
      },
      onUploadProgress,
    }
  );
};

// ✅ Fetch Sheet Data (Authorized)
export const fetchSheetData = (token) => {
  return axios.post(
    `${BASE_URL}/webhook/5e548372-9e30-4929-a684-5ecf547e104b`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        // ❌ No need for Content-Type (axios handles it)
      },
    }
  );
};

// ✅ Generate Report (Authorized)
export const generateReport = (sheetName, token) => {
  return axios.post(
    `${BASE_URL}/webhook/7b7c6ed7-3b3d-45b3-bcb4-3afecd2262b1`,
    { sheetName },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        // ❌ No need to manually set Content-Type
      },
    }
  );
};
